import * as Search from "./Search/index.js";
import * as Detail from "./Detail/index.js";
import * as BrokerListingCounts from "./BrokerListingCounts/index.js";
import * as IntegrationTest from "./IntegrationTest/index.js";
import * as AuctionDetail from "./AuctionDetail/index.js";
import * as LoanDetail from "./LoanDetail/index.js";
import * as PointsOfInterest from "./PointsOfInterest/index.js";
import * as PropertyRecord from "./PropertyRecord/index.js";
import * as UnitMix from "./UnitMix/index.js";
/** CoStar.Api.Listings.ViewModels.ActivityType */
export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["None"] = 0] = "None";
    ActivityType[ActivityType["Search"] = 1] = "Search";
    ActivityType[ActivityType["PlacardView"] = 2] = "PlacardView";
    ActivityType[ActivityType["DetailView"] = 3] = "DetailView";
})(ActivityType || (ActivityType = {}));
import { MeasurementConversion } from "../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.Listings.ViewModels.MeasurementConversion */
export { MeasurementConversion };
/** CoStar.Api.Listings.ViewModels.CurrencyType */
export var CurrencyType;
(function (CurrencyType) {
    CurrencyType[CurrencyType["None"] = 0] = "None";
    CurrencyType[CurrencyType["USDollar"] = 1] = "USDollar";
    CurrencyType[CurrencyType["CanadianDollar"] = 2] = "CanadianDollar";
    CurrencyType[CurrencyType["PoundSterling"] = 3] = "PoundSterling";
    CurrencyType[CurrencyType["Euro"] = 4] = "Euro";
    CurrencyType[CurrencyType["SwissFranc"] = 7] = "SwissFranc";
    CurrencyType[CurrencyType["CzechKoruna"] = 40] = "CzechKoruna";
    CurrencyType[CurrencyType["DanishKrone"] = 42] = "DanishKrone";
    CurrencyType[CurrencyType["HungarianForint"] = 57] = "HungarianForint";
    CurrencyType[CurrencyType["MexicanPeso"] = 89] = "MexicanPeso";
    CurrencyType[CurrencyType["NorwegianKrone"] = 95] = "NorwegianKrone";
    CurrencyType[CurrencyType["PolishZloty"] = 104] = "PolishZloty";
    CurrencyType[CurrencyType["SwedishKrona"] = 115] = "SwedishKrona";
})(CurrencyType || (CurrencyType = {}));
/** CoStar.Api.Listings.ViewModels.ContactDetailsMode */
export var ContactDetailsMode;
(function (ContactDetailsMode) {
    ContactDetailsMode[ContactDetailsMode["None"] = 0] = "None";
    ContactDetailsMode[ContactDetailsMode["AddressOnly"] = 1] = "AddressOnly";
    ContactDetailsMode[ContactDetailsMode["AddressAndBio"] = 2] = "AddressAndBio";
})(ContactDetailsMode || (ContactDetailsMode = {}));
/** CoStar.Api.Listings.ViewModels.VisibilityMode */
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode[VisibilityMode["Free"] = 0] = "Free";
    VisibilityMode[VisibilityMode["SearchEngineOptimization"] = 1] = "SearchEngineOptimization";
    VisibilityMode[VisibilityMode["ListingSite"] = 2] = "ListingSite";
    VisibilityMode[VisibilityMode["Broker"] = 3] = "Broker";
    VisibilityMode[VisibilityMode["Premium"] = 4] = "Premium";
    VisibilityMode[VisibilityMode["ReallaFree"] = 5] = "ReallaFree";
    VisibilityMode[VisibilityMode["ReallaAll"] = 6] = "ReallaAll";
    VisibilityMode[VisibilityMode["BelBexAll"] = 7] = "BelBexAll";
})(VisibilityMode || (VisibilityMode = {}));
/** CoStar.Api.Listings.ViewModels.RentBasis */
export var RentBasis;
(function (RentBasis) {
    RentBasis[RentBasis["Yearly"] = 0] = "Yearly";
    RentBasis[RentBasis["Monthly"] = 1] = "Monthly";
})(RentBasis || (RentBasis = {}));
/** CoStar.Api.Listings.ViewModels.RentRateType */
export var RentRateType;
(function (RentRateType) {
    RentRateType[RentRateType["Total"] = 0] = "Total";
    RentRateType[RentRateType["PerSpaceAvailableArea"] = 1] = "PerSpaceAvailableArea";
})(RentRateType || (RentRateType = {}));
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.Listings.ViewModels.AreaMeasure */
export { AreaMeasure };
/** CoStar.Api.Listings.ViewModels.PriceRateType */
export var PriceRateType;
(function (PriceRateType) {
    PriceRateType[PriceRateType["Total"] = 0] = "Total";
    PriceRateType[PriceRateType["PerBuildingArea"] = 1] = "PerBuildingArea";
    PriceRateType[PriceRateType["PerLandArea"] = 2] = "PerLandArea";
    PriceRateType[PriceRateType["PerItem"] = 3] = "PerItem";
})(PriceRateType || (PriceRateType = {}));
import { LengthMeasure } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.Listings.ViewModels.LengthMeasure */
export { LengthMeasure };
/** CoStar.Api.Listings.ViewModels.ProposedLandUse */
export var ProposedLandUse;
(function (ProposedLandUse) {
    ProposedLandUse[ProposedLandUse["None"] = 0] = "None";
    ProposedLandUse[ProposedLandUse["Commercial"] = 1] = "Commercial";
    ProposedLandUse[ProposedLandUse["Industrial"] = 2] = "Industrial";
    ProposedLandUse[ProposedLandUse["Retail"] = 3] = "Retail";
    ProposedLandUse[ProposedLandUse["Office"] = 4] = "Office";
    ProposedLandUse[ProposedLandUse["MixedUse"] = 5] = "MixedUse";
    ProposedLandUse[ProposedLandUse["Multifamily"] = 6] = "Multifamily";
    ProposedLandUse[ProposedLandUse["Hospitality"] = 7] = "Hospitality";
    ProposedLandUse[ProposedLandUse["AirplaneHangar"] = 8] = "AirplaneHangar";
    ProposedLandUse[ProposedLandUse["Airport"] = 9] = "Airport";
    ProposedLandUse[ProposedLandUse["ApartmentUnits"] = 10] = "ApartmentUnits";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsCondo"] = 11] = "ApartmentUnitsCondo";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsDorms"] = 12] = "ApartmentUnitsDorms";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSenior"] = 13] = "ApartmentUnitsSenior";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSubsidized"] = 14] = "ApartmentUnitsSubsidized";
    ProposedLandUse[ProposedLandUse["AutoDealership"] = 15] = "AutoDealership";
    ProposedLandUse[ProposedLandUse["AutoRepair"] = 16] = "AutoRepair";
    ProposedLandUse[ProposedLandUse["AutoSalvageFacility"] = 17] = "AutoSalvageFacility";
    ProposedLandUse[ProposedLandUse["Bank"] = 18] = "Bank";
    ProposedLandUse[ProposedLandUse["Bar"] = 19] = "Bar";
    ProposedLandUse[ProposedLandUse["BaseballField"] = 20] = "BaseballField";
    ProposedLandUse[ProposedLandUse["BowlingAlley"] = 21] = "BowlingAlley";
    ProposedLandUse[ProposedLandUse["Carwash"] = 22] = "Carwash";
    ProposedLandUse[ProposedLandUse["Casino"] = 23] = "Casino";
    ProposedLandUse[ProposedLandUse["CementOrGravelPlant"] = 24] = "CementOrGravelPlant";
    ProposedLandUse[ProposedLandUse["CemeteryOrMausoleum"] = 25] = "CemeteryOrMausoleum";
    ProposedLandUse[ProposedLandUse["ChemicalOrOilRefinery"] = 26] = "ChemicalOrOilRefinery";
    ProposedLandUse[ProposedLandUse["CommunityCenter"] = 27] = "CommunityCenter";
    ProposedLandUse[ProposedLandUse["ContractorStorageYard"] = 28] = "ContractorStorageYard";
    ProposedLandUse[ProposedLandUse["ConvenienceStore"] = 29] = "ConvenienceStore";
    ProposedLandUse[ProposedLandUse["CorrectionalFacility"] = 30] = "CorrectionalFacility";
    ProposedLandUse[ProposedLandUse["DaycareCenter"] = 31] = "DaycareCenter";
    ProposedLandUse[ProposedLandUse["DepartmentStore"] = 32] = "DepartmentStore";
    ProposedLandUse[ProposedLandUse["Distribution"] = 33] = "Distribution";
    ProposedLandUse[ProposedLandUse["Drugstore"] = 34] = "Drugstore";
    ProposedLandUse[ProposedLandUse["FastFood"] = 35] = "FastFood";
    ProposedLandUse[ProposedLandUse["FoodProcessing"] = 36] = "FoodProcessing";
    ProposedLandUse[ProposedLandUse["FuneralHome"] = 37] = "FuneralHome";
    ProposedLandUse[ProposedLandUse["GardenCenter"] = 38] = "GardenCenter";
    ProposedLandUse[ProposedLandUse["GeneralFreestanding"] = 39] = "GeneralFreestanding";
    ProposedLandUse[ProposedLandUse["GolfCourseOrDrivingRange"] = 40] = "GolfCourseOrDrivingRange";
    ProposedLandUse[ProposedLandUse["Healthcare"] = 41] = "Healthcare";
    ProposedLandUse[ProposedLandUse["HealthClub"] = 42] = "HealthClub";
    ProposedLandUse[ProposedLandUse["HoldForDevelopment"] = 43] = "HoldForDevelopment";
    ProposedLandUse[ProposedLandUse["HoldForInvestment"] = 44] = "HoldForInvestment";
    ProposedLandUse[ProposedLandUse["HorseStables"] = 45] = "HorseStables";
    ProposedLandUse[ProposedLandUse["Hospital"] = 46] = "Hospital";
    ProposedLandUse[ProposedLandUse["Hotel"] = 47] = "Hotel";
    ProposedLandUse[ProposedLandUse["IndustrialLiveOrWorkUnit"] = 48] = "IndustrialLiveOrWorkUnit";
    ProposedLandUse[ProposedLandUse["IndustrialPark"] = 49] = "IndustrialPark";
    ProposedLandUse[ProposedLandUse["Landfill"] = 50] = "Landfill";
    ProposedLandUse[ProposedLandUse["LodgeOrMeetingHall"] = 51] = "LodgeOrMeetingHall";
    ProposedLandUse[ProposedLandUse["LoftOrCreativeSpace"] = 52] = "LoftOrCreativeSpace";
    ProposedLandUse[ProposedLandUse["Lumberyard"] = 53] = "Lumberyard";
    ProposedLandUse[ProposedLandUse["ManufacturedHomesOrMobileHomePark"] = 54] = "ManufacturedHomesOrMobileHomePark";
    ProposedLandUse[ProposedLandUse["Marina"] = 55] = "Marina";
    ProposedLandUse[ProposedLandUse["MasterPlannedCommunity"] = 56] = "MasterPlannedCommunity";
    ProposedLandUse[ProposedLandUse["Medical"] = 57] = "Medical";
    ProposedLandUse[ProposedLandUse["Motel"] = 58] = "Motel";
    ProposedLandUse[ProposedLandUse["MovieTheater"] = 59] = "MovieTheater";
    ProposedLandUse[ProposedLandUse["MovieOrRadioOrTelevisionStudio"] = 60] = "MovieOrRadioOrTelevisionStudio";
    ProposedLandUse[ProposedLandUse["NeighborhoodCenter"] = 61] = "NeighborhoodCenter";
    ProposedLandUse[ProposedLandUse["OfficePark"] = 62] = "OfficePark";
    ProposedLandUse[ProposedLandUse["OpenSpace"] = 63] = "OpenSpace";
    ProposedLandUse[ProposedLandUse["OutletCenter"] = 64] = "OutletCenter";
    ProposedLandUse[ProposedLandUse["ParkingGarage"] = 65] = "ParkingGarage";
    ProposedLandUse[ProposedLandUse["ParkingLot"] = 66] = "ParkingLot";
    ProposedLandUse[ProposedLandUse["PlannedUnitDevelopment"] = 67] = "PlannedUnitDevelopment";
    ProposedLandUse[ProposedLandUse["PoliceOrFireStation"] = 68] = "PoliceOrFireStation";
    ProposedLandUse[ProposedLandUse["PostOffice"] = 69] = "PostOffice";
    ProposedLandUse[ProposedLandUse["PowerCenter"] = 70] = "PowerCenter";
    ProposedLandUse[ProposedLandUse["PublicLibrary"] = 71] = "PublicLibrary";
    ProposedLandUse[ProposedLandUse["PublicPark"] = 72] = "PublicPark";
    ProposedLandUse[ProposedLandUse["PublicSwimmingPool"] = 73] = "PublicSwimmingPool";
    ProposedLandUse[ProposedLandUse["ResearchAndDevelopment"] = 74] = "ResearchAndDevelopment";
    ProposedLandUse[ProposedLandUse["Racetrack"] = 75] = "Racetrack";
    ProposedLandUse[ProposedLandUse["RadioOrTelevisionTransmissionFacility"] = 76] = "RadioOrTelevisionTransmissionFacility";
    ProposedLandUse[ProposedLandUse["RailroadYard"] = 77] = "RailroadYard";
    ProposedLandUse[ProposedLandUse["RecyclingCenter"] = 78] = "RecyclingCenter";
    ProposedLandUse[ProposedLandUse["RefrigerationOrColdStorage"] = 79] = "RefrigerationOrColdStorage";
    ProposedLandUse[ProposedLandUse["RegionalMall"] = 80] = "RegionalMall";
    ProposedLandUse[ProposedLandUse["RehabilitationCenter"] = 81] = "RehabilitationCenter";
    ProposedLandUse[ProposedLandUse["ReligiousFacility"] = 82] = "ReligiousFacility";
    ProposedLandUse[ProposedLandUse["Restaurant"] = 83] = "Restaurant";
    ProposedLandUse[ProposedLandUse["RetailWarehouse"] = 84] = "RetailWarehouse";
    ProposedLandUse[ProposedLandUse["Schools"] = 85] = "Schools";
    ProposedLandUse[ProposedLandUse["SelfStorage"] = 86] = "SelfStorage";
    ProposedLandUse[ProposedLandUse["ServiceStation"] = 87] = "ServiceStation";
    ProposedLandUse[ProposedLandUse["Shelter"] = 88] = "Shelter";
    ProposedLandUse[ProposedLandUse["Shipyard"] = 89] = "Shipyard";
    ProposedLandUse[ProposedLandUse["SingleFamilyDevelopment"] = 90] = "SingleFamilyDevelopment";
    ProposedLandUse[ProposedLandUse["SkatingRink"] = 91] = "SkatingRink";
    ProposedLandUse[ProposedLandUse["SpecialtyOrFestivalOrEntertainment"] = 92] = "SpecialtyOrFestivalOrEntertainment";
    ProposedLandUse[ProposedLandUse["Storefront"] = 93] = "Storefront";
    ProposedLandUse[ProposedLandUse["StorefrontRetailOrOffice"] = 94] = "StorefrontRetailOrOffice";
    ProposedLandUse[ProposedLandUse["StorefrontRetailOrResidential"] = 95] = "StorefrontRetailOrResidential";
    ProposedLandUse[ProposedLandUse["StripCenter"] = 96] = "StripCenter";
    ProposedLandUse[ProposedLandUse["Supermarket"] = 97] = "Supermarket";
    ProposedLandUse[ProposedLandUse["TheaterOrConcertHall"] = 98] = "TheaterOrConcertHall";
    ProposedLandUse[ProposedLandUse["TrailerOrCamperPark"] = 99] = "TrailerOrCamperPark";
    ProposedLandUse[ProposedLandUse["TruckStop"] = 100] = "TruckStop";
    ProposedLandUse[ProposedLandUse["TruckTerminal"] = 101] = "TruckTerminal";
    ProposedLandUse[ProposedLandUse["Unknown"] = 102] = "Unknown";
    ProposedLandUse[ProposedLandUse["UtilitySubstation"] = 103] = "UtilitySubstation";
    ProposedLandUse[ProposedLandUse["VeterinarianOrKennel"] = 104] = "VeterinarianOrKennel";
    ProposedLandUse[ProposedLandUse["Warehouse"] = 105] = "Warehouse";
    ProposedLandUse[ProposedLandUse["WaterRetentionFacility"] = 106] = "WaterRetentionFacility";
    ProposedLandUse[ProposedLandUse["WaterTreatmentFacility"] = 107] = "WaterTreatmentFacility";
    ProposedLandUse[ProposedLandUse["WineryOrVineyard"] = 108] = "WineryOrVineyard";
    ProposedLandUse[ProposedLandUse["AmusementPark"] = 109] = "AmusementPark";
    ProposedLandUse[ProposedLandUse["Agricultural"] = 110] = "Agricultural";
    ProposedLandUse[ProposedLandUse["Agribusiness"] = 111] = "Agribusiness";
    ProposedLandUse[ProposedLandUse["PastureRanch"] = 112] = "PastureRanch";
    ProposedLandUse[ProposedLandUse["Timberland"] = 113] = "Timberland";
    ProposedLandUse[ProposedLandUse["SingleFamilyResidence"] = 114] = "SingleFamilyResidence";
})(ProposedLandUse || (ProposedLandUse = {}));
import { ListingAdLevel } from "../../../../CoStar/Api/ListingAdvertising/ViewModels/Enum/index.js";
/** CoStar.Api.Listings.ViewModels.ListingAdLevel */
export { ListingAdLevel };
/** CoStar.Api.Listings.ViewModels.DateMeasure */
export var DateMeasure;
(function (DateMeasure) {
    DateMeasure[DateMeasure["None"] = 0] = "None";
    DateMeasure[DateMeasure["Day"] = 1] = "Day";
    DateMeasure[DateMeasure["Week"] = 2] = "Week";
    DateMeasure[DateMeasure["Month"] = 3] = "Month";
    DateMeasure[DateMeasure["Year"] = 4] = "Year";
})(DateMeasure || (DateMeasure = {}));
/** CoStar.Api.Listings.ViewModels.ListingPinOptions */
export var ListingPinOptions;
(function (ListingPinOptions) {
    ListingPinOptions[ListingPinOptions["None"] = 0] = "None";
    ListingPinOptions[ListingPinOptions["RestrictedVisibility"] = 1] = "RestrictedVisibility";
    ListingPinOptions[ListingPinOptions["Licensed"] = 2] = "Licensed";
})(ListingPinOptions || (ListingPinOptions = {}));
/** CoStar.Api.Listings.ViewModels.PinType */
export var PinType;
(function (PinType) {
    PinType[PinType["Normal"] = 1] = "Normal";
    PinType[PinType["SuppressedAddress"] = 2] = "SuppressedAddress";
    PinType[PinType["Disconnected"] = 3] = "Disconnected";
})(PinType || (PinType = {}));
/** CoStar.Api.Listings.ViewModels.PropertyFinancialAmountType */
export var PropertyFinancialAmountType;
(function (PropertyFinancialAmountType) {
    PropertyFinancialAmountType[PropertyFinancialAmountType["None"] = 0] = "None";
    PropertyFinancialAmountType[PropertyFinancialAmountType["YearlyAmount"] = 1] = "YearlyAmount";
    PropertyFinancialAmountType[PropertyFinancialAmountType["RatePerBuildingArea"] = 2] = "RatePerBuildingArea";
})(PropertyFinancialAmountType || (PropertyFinancialAmountType = {}));
/** CoStar.Api.Listings.ViewModels.PropertyFinancialType */
export var PropertyFinancialType;
(function (PropertyFinancialType) {
    PropertyFinancialType[PropertyFinancialType["None"] = 0] = "None";
    PropertyFinancialType[PropertyFinancialType["ProForma"] = 1] = "ProForma";
    PropertyFinancialType[PropertyFinancialType["Actual"] = 2] = "Actual";
})(PropertyFinancialType || (PropertyFinancialType = {}));
/** CoStar.Api.Listings.ViewModels.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["BuildingName"] = 4] = "BuildingName";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["Contact"] = 8] = "Contact";
    MatchType[MatchType["Company"] = 9] = "Company";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["StoreType"] = 18] = "StoreType";
    MatchType[MatchType["CSA"] = 19] = "CSA";
    MatchType[MatchType["PropertyResidential"] = 20] = "PropertyResidential";
    MatchType[MatchType["Cluster"] = 21] = "Cluster";
    MatchType[MatchType["Airport"] = 22] = "Airport";
    MatchType[MatchType["HotelName"] = 23] = "HotelName";
    MatchType[MatchType["TransitStation"] = 24] = "TransitStation";
    MatchType[MatchType["Military"] = 25] = "Military";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["StoreBrand"] = 27] = "StoreBrand";
    MatchType[MatchType["GoogleResults"] = 28] = "GoogleResults";
    MatchType[MatchType["PropertyManagers"] = 29] = "PropertyManagers";
    MatchType[MatchType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    MatchType[MatchType["StreetIntersections"] = 31] = "StreetIntersections";
    MatchType[MatchType["Metro"] = 32] = "Metro";
    MatchType[MatchType["ParkAndRecreation"] = 33] = "ParkAndRecreation";
    MatchType[MatchType["ActiveCompany"] = 34] = "ActiveCompany";
    MatchType[MatchType["TenantLocation"] = 35] = "TenantLocation";
    MatchType[MatchType["TrueOwner"] = 36] = "TrueOwner";
    MatchType[MatchType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    MatchType[MatchType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    MatchType[MatchType["SchoolDistrict"] = 39] = "SchoolDistrict";
    MatchType[MatchType["CityAggregate"] = 40] = "CityAggregate";
    MatchType[MatchType["MultifamilyProperty"] = 41] = "MultifamilyProperty";
    MatchType[MatchType["PropertyGroup"] = 42] = "PropertyGroup";
    MatchType[MatchType["DMA"] = 43] = "DMA";
    MatchType[MatchType["CoStarMarket"] = 132] = "CoStarMarket";
    MatchType[MatchType["TrueCity"] = 133] = "TrueCity";
    MatchType[MatchType["CensusRegion"] = 134] = "CensusRegion";
})(MatchType || (MatchType = {}));
/** CoStar.Api.Listings.ViewModels.ListingStatus */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["None"] = 0] = "None";
    ListingStatus[ListingStatus["Active"] = 1] = "Active";
    ListingStatus[ListingStatus["Pending"] = 2] = "Pending";
    ListingStatus[ListingStatus["OffMarket"] = 3] = "OffMarket";
    ListingStatus[ListingStatus["Terminate"] = 4] = "Terminate";
    ListingStatus[ListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatus[ListingStatus["Unpublished"] = 6] = "Unpublished";
    ListingStatus[ListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatus[ListingStatus["UserDeleted"] = 8] = "UserDeleted";
    ListingStatus[ListingStatus["Upsell"] = 9] = "Upsell";
    ListingStatus[ListingStatus["Confidential"] = 10] = "Confidential";
    ListingStatus[ListingStatus["Introduction"] = 11] = "Introduction";
    ListingStatus[ListingStatus["Migrated"] = 12] = "Migrated";
    ListingStatus[ListingStatus["Draft"] = 13] = "Draft";
})(ListingStatus || (ListingStatus = {}));
/** CoStar.Api.Listings.ViewModels.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["None"] = 0] = "None";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsAndEntertainment"] = 8] = "SportsAndEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["Unknown"] = 14] = "Unknown";
})(PropertyType || (PropertyType = {}));
/** CoStar.Api.Listings.ViewModels.SpaceUse */
export var SpaceUse;
(function (SpaceUse) {
    SpaceUse[SpaceUse["None"] = 0] = "None";
    SpaceUse[SpaceUse["Office"] = 1] = "Office";
    SpaceUse[SpaceUse["OfficeMedical"] = 2] = "OfficeMedical";
    SpaceUse[SpaceUse["OfficeRetail"] = 3] = "OfficeRetail";
    SpaceUse[SpaceUse["Medical"] = 4] = "Medical";
    SpaceUse[SpaceUse["Retail"] = 5] = "Retail";
    SpaceUse[SpaceUse["Flex"] = 6] = "Flex";
    SpaceUse[SpaceUse["Industrial"] = 7] = "Industrial";
})(SpaceUse || (SpaceUse = {}));
/** CoStar.Api.Listings.ViewModels.SaleType */
export var SaleType;
(function (SaleType) {
    SaleType[SaleType["None"] = 0] = "None";
    SaleType[SaleType["Investment"] = 1] = "Investment";
    SaleType[SaleType["OwnerUser"] = 2] = "OwnerUser";
    SaleType[SaleType["InvestmentOrOwnerUser"] = 3] = "InvestmentOrOwnerUser";
})(SaleType || (SaleType = {}));
/** CoStar.Api.Listings.ViewModels.SaleCondition */
export var SaleCondition;
(function (SaleCondition) {
    SaleCondition[SaleCondition["None"] = 0] = "None";
    SaleCondition[SaleCondition["DistressSale"] = 1] = "DistressSale";
    SaleCondition[SaleCondition["TenThirtyOneExchange"] = 2] = "TenThirtyOneExchange";
    SaleCondition[SaleCondition["SaleLeaseback"] = 3] = "SaleLeaseback";
    SaleCondition[SaleCondition["GroundLeaseLeasehold"] = 4] = "GroundLeaseLeasehold";
    SaleCondition[SaleCondition["GroundLeaseLeasedFee"] = 5] = "GroundLeaseLeasedFee";
    SaleCondition[SaleCondition["InvestmentTripleNet"] = 6] = "InvestmentTripleNet";
    SaleCondition[SaleCondition["DirectExchange"] = 7] = "DirectExchange";
    SaleCondition[SaleCondition["Assemblage"] = 8] = "Assemblage";
    SaleCondition[SaleCondition["AuctionSale"] = 9] = "AuctionSale";
    SaleCondition[SaleCondition["BuildToSuit"] = 11] = "BuildToSuit";
    SaleCondition[SaleCondition["BulkPortfolioSale"] = 12] = "BulkPortfolioSale";
    SaleCondition[SaleCondition["BusinessValueIncluded"] = 13] = "BusinessValueIncluded";
    SaleCondition[SaleCondition["CondoConversion"] = 14] = "CondoConversion";
    SaleCondition[SaleCondition["DeedRestriction"] = 15] = "DeedRestriction";
    SaleCondition[SaleCondition["EstateProbateSale"] = 16] = "EstateProbateSale";
    SaleCondition[SaleCondition["HistoricalSite"] = 17] = "HistoricalSite";
    SaleCondition[SaleCondition["LeaseOption"] = 18] = "LeaseOption";
    SaleCondition[SaleCondition["BuildingContaminationIssue"] = 19] = "BuildingContaminationIssue";
    SaleCondition[SaleCondition["DeferredMaintenance"] = 20] = "DeferredMaintenance";
    SaleCondition[SaleCondition["DoubleEscrow"] = 21] = "DoubleEscrow";
    SaleCondition[SaleCondition["ExerciseOfOption"] = 22] = "ExerciseOfOption";
    SaleCondition[SaleCondition["ExcessLand"] = 23] = "ExcessLand";
    SaleCondition[SaleCondition["Expansion"] = 24] = "Expansion";
    SaleCondition[SaleCondition["HighVacancyProperty"] = 25] = "HighVacancyProperty";
    SaleCondition[SaleCondition["LandContract"] = 26] = "LandContract";
    SaleCondition[SaleCondition["PartialInterestTransfer"] = 27] = "PartialInterestTransfer";
    SaleCondition[SaleCondition["PurchaseByTenant"] = 28] = "PurchaseByTenant";
    SaleCondition[SaleCondition["RedevelopmentProject"] = 29] = "RedevelopmentProject";
    SaleCondition[SaleCondition["RollingOptionTakedown"] = 30] = "RollingOptionTakedown";
    SaleCondition[SaleCondition["SoilContaminationIssue"] = 31] = "SoilContaminationIssue";
    SaleCondition[SaleCondition["BuildingInShellCondition"] = 32] = "BuildingInShellCondition";
    SaleCondition[SaleCondition["RealEstateOwned"] = 33] = "RealEstateOwned";
    SaleCondition[SaleCondition["ShortSale"] = 34] = "ShortSale";
    SaleCondition[SaleCondition["ThreatOfCondemnation"] = 35] = "ThreatOfCondemnation";
    SaleCondition[SaleCondition["CourtAppointedSale"] = 36] = "CourtAppointedSale";
    SaleCondition[SaleCondition["Recapitalization"] = 37] = "Recapitalization";
    SaleCondition[SaleCondition["DebtAssumption"] = 38] = "DebtAssumption";
    SaleCondition[SaleCondition["NotePurchase"] = 39] = "NotePurchase";
    SaleCondition[SaleCondition["BankruptcySale"] = 40] = "BankruptcySale";
    SaleCondition[SaleCondition["ZeroCashFlowInvestment"] = 41] = "ZeroCashFlowInvestment";
    SaleCondition[SaleCondition["LowIncomeHousingTaxCredit"] = 42] = "LowIncomeHousingTaxCredit";
    SaleCondition[SaleCondition["EntityBuyMembershipInterests"] = 43] = "EntityBuyMembershipInterests";
    SaleCondition[SaleCondition["CondoConversionUndo"] = 44] = "CondoConversionUndo";
    SaleCondition[SaleCondition["FurnitureFixturesEquipmentIncluded"] = 45] = "FurnitureFixturesEquipmentIncluded";
    SaleCondition[SaleCondition["HotelBrandChange"] = 46] = "HotelBrandChange";
    SaleCondition[SaleCondition["LongTermEncumbrance"] = 47] = "LongTermEncumbrance";
})(SaleCondition || (SaleCondition = {}));
/** CoStar.Api.Listings.ViewModels.SaleStatus */
export var SaleStatus;
(function (SaleStatus) {
    SaleStatus[SaleStatus["None"] = 0] = "None";
    SaleStatus[SaleStatus["Active"] = 1] = "Active";
    SaleStatus[SaleStatus["Escrow"] = 2] = "Escrow";
    SaleStatus[SaleStatus["Pending"] = 3] = "Pending";
    SaleStatus[SaleStatus["UnderContract"] = 4] = "UnderContract";
    SaleStatus[SaleStatus["Sold"] = 5] = "Sold";
    SaleStatus[SaleStatus["Withdrawn"] = 6] = "Withdrawn";
    SaleStatus[SaleStatus["Leased"] = 7] = "Leased";
    SaleStatus[SaleStatus["Rubbish"] = 12] = "Rubbish";
    SaleStatus[SaleStatus["Occupied"] = 13] = "Occupied";
})(SaleStatus || (SaleStatus = {}));
/** CoStar.Api.Listings.ViewModels.TimeZone */
export var TimeZone;
(function (TimeZone) {
    TimeZone[TimeZone["None"] = 0] = "None";
    TimeZone[TimeZone["PacificHonolulu"] = 1] = "PacificHonolulu";
    TimeZone[TimeZone["AmericaAnchorage"] = 2] = "AmericaAnchorage";
    TimeZone[TimeZone["AmericaLosAngeles"] = 3] = "AmericaLosAngeles";
    TimeZone[TimeZone["USArizona"] = 4] = "USArizona";
    TimeZone[TimeZone["AmericaDenver"] = 5] = "AmericaDenver";
    TimeZone[TimeZone["AmericaChicago"] = 6] = "AmericaChicago";
    TimeZone[TimeZone["AmericaNewYork"] = 7] = "AmericaNewYork";
    TimeZone[TimeZone["CanadaAtlantic"] = 8] = "CanadaAtlantic";
    TimeZone[TimeZone["CanadaNewfoundland"] = 9] = "CanadaNewfoundland";
    TimeZone[TimeZone["AmericaGodthab"] = 10] = "AmericaGodthab";
    TimeZone[TimeZone["AtlanticAzores"] = 11] = "AtlanticAzores";
    TimeZone[TimeZone["Greenwich"] = 12] = "Greenwich";
    TimeZone[TimeZone["EuropeBerlin"] = 13] = "EuropeBerlin";
})(TimeZone || (TimeZone = {}));
/** CoStar.Api.Listings.ViewModels.Tenure */
export var Tenure;
(function (Tenure) {
    Tenure[Tenure["None"] = 0] = "None";
    Tenure[Tenure["Freehold"] = 1] = "Freehold";
    Tenure[Tenure["LongLeasehold"] = 2] = "LongLeasehold";
    Tenure[Tenure["FreeholdLongLeasehold"] = 3] = "FreeholdLongLeasehold";
})(Tenure || (Tenure = {}));
/** CoStar.Api.Listings.ViewModels.ServiceType */
export var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["None"] = 0] = "None";
    ServiceType[ServiceType["PlusCleaning"] = 1] = "PlusCleaning";
    ServiceType[ServiceType["PlusElectricAndCleaning"] = 2] = "PlusElectricAndCleaning";
    ServiceType[ServiceType["PlusElectric"] = 4] = "PlusElectric";
    ServiceType[ServiceType["UtilitiesAndChar"] = 5] = "UtilitiesAndChar";
    ServiceType[ServiceType["PlusAllUtilities"] = 6] = "PlusAllUtilities";
    ServiceType[ServiceType["FullServiceGross"] = 7] = "FullServiceGross";
    ServiceType[ServiceType["IndustrialGross"] = 8] = "IndustrialGross";
    ServiceType[ServiceType["ModifiedGross"] = 9] = "ModifiedGross";
    ServiceType[ServiceType["Net"] = 10] = "Net";
    ServiceType[ServiceType["Negotiable"] = 11] = "Negotiable";
    ServiceType[ServiceType["DoubleNet"] = 12] = "DoubleNet";
    ServiceType[ServiceType["TripleNet"] = 13] = "TripleNet";
    ServiceType[ServiceType["ToBeDetermined"] = 14] = "ToBeDetermined";
    ServiceType[ServiceType["TenantElectric"] = 15] = "TenantElectric";
    ServiceType[ServiceType["FullyRepairingAndInsuring"] = 16] = "FullyRepairingAndInsuring";
    ServiceType[ServiceType["InternalRepairingOnly"] = 17] = "InternalRepairingOnly";
    ServiceType[ServiceType["InternalRepairingAndInsuring"] = 18] = "InternalRepairingAndInsuring";
    ServiceType[ServiceType["FullServiceGrossNoPass"] = 19] = "FullServiceGrossNoPass";
})(ServiceType || (ServiceType = {}));
/** CoStar.Api.Listings.ViewModels.LeaseTermType */
export var LeaseTermType;
(function (LeaseTermType) {
    LeaseTermType[LeaseTermType["None"] = 0] = "None";
    LeaseTermType[LeaseTermType["Years"] = 1] = "Years";
    LeaseTermType[LeaseTermType["Months"] = 2] = "Months";
    LeaseTermType[LeaseTermType["Days"] = 3] = "Days";
    LeaseTermType[LeaseTermType["ToBeDetermined"] = 4] = "ToBeDetermined";
    LeaseTermType[LeaseTermType["Negotiable"] = 5] = "Negotiable";
    LeaseTermType[LeaseTermType["ThreeSixNine"] = 6] = "ThreeSixNine";
    LeaseTermType[LeaseTermType["ShortTerm"] = 7] = "ShortTerm";
})(LeaseTermType || (LeaseTermType = {}));
import { SpaceType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Listings.ViewModels.SpaceType */
export { SpaceType };
import { BuildOutCondition } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Listings.ViewModels.BuildOutCondition */
export { BuildOutCondition };
/** CoStar.Api.Listings.ViewModels.BuildOut */
export var BuildOut;
(function (BuildOut) {
    BuildOut[BuildOut["None"] = 0] = "None";
    BuildOut[BuildOut["StandardOffice"] = 1] = "StandardOffice";
    BuildOut[BuildOut["FinancialServices"] = 2] = "FinancialServices";
    BuildOut[BuildOut["ProfessionalServices"] = 3] = "ProfessionalServices";
    BuildOut[BuildOut["LawFirm"] = 4] = "LawFirm";
    BuildOut[BuildOut["CallCenter"] = 5] = "CallCenter";
    BuildOut[BuildOut["GovernmentFacility"] = 7] = "GovernmentFacility";
    BuildOut[BuildOut["LiveWork"] = 8] = "LiveWork";
    BuildOut[BuildOut["StandardIndustrial"] = 9] = "StandardIndustrial";
    BuildOut[BuildOut["StorageAndDistribution"] = 10] = "StorageAndDistribution";
    BuildOut[BuildOut["SelfStorage"] = 11] = "SelfStorage";
    BuildOut[BuildOut["Warehouse"] = 12] = "Warehouse";
    BuildOut[BuildOut["StandardRetail"] = 13] = "StandardRetail";
    BuildOut[BuildOut["RestaurantsAndCafes"] = 14] = "RestaurantsAndCafes";
    BuildOut[BuildOut["FastFood"] = 15] = "FastFood";
    BuildOut[BuildOut["Bank"] = 16] = "Bank";
    BuildOut[BuildOut["ConvenienceStore"] = 17] = "ConvenienceStore";
    BuildOut[BuildOut["DrinkingEstablishment"] = 18] = "DrinkingEstablishment";
    BuildOut[BuildOut["StandardFlex"] = 19] = "StandardFlex";
    BuildOut[BuildOut["StandardMedical"] = 21] = "StandardMedical";
    BuildOut[BuildOut["Dental"] = 22] = "Dental";
    BuildOut[BuildOut["PhysicalTherapy"] = 23] = "PhysicalTherapy";
    BuildOut[BuildOut["ResearchAndDevelopment"] = 24] = "ResearchAndDevelopment";
    BuildOut[BuildOut["Healthcare"] = 25] = "Healthcare";
    BuildOut[BuildOut["Specialty"] = 26] = "Specialty";
    BuildOut[BuildOut["ReligiousFacility"] = 28] = "ReligiousFacility";
    BuildOut[BuildOut["MovieTheater"] = 29] = "MovieTheater";
    BuildOut[BuildOut["PopupTemporary"] = 30] = "PopupTemporary";
    BuildOut[BuildOut["PoliceFireStation"] = 31] = "PoliceFireStation";
    BuildOut[BuildOut["PostOffice"] = 32] = "PostOffice";
    BuildOut[BuildOut["CarDealership"] = 33] = "CarDealership";
    BuildOut[BuildOut["QuickService"] = 34] = "QuickService";
})(BuildOut || (BuildOut = {}));
/** CoStar.Api.Listings.ViewModels.BuildOutStatus */
export var BuildOutStatus;
(function (BuildOutStatus) {
    BuildOutStatus[BuildOutStatus["None"] = 0] = "None";
    BuildOutStatus[BuildOutStatus["RawSpace"] = 1] = "RawSpace";
    BuildOutStatus[BuildOutStatus["ShellSpace"] = 2] = "ShellSpace";
    BuildOutStatus[BuildOutStatus["PartialBuildOut"] = 3] = "PartialBuildOut";
    BuildOutStatus[BuildOutStatus["FullBuildOut"] = 4] = "FullBuildOut";
    BuildOutStatus[BuildOutStatus["SpecSuite"] = 5] = "SpecSuite";
})(BuildOutStatus || (BuildOutStatus = {}));
/** CoStar.Api.Listings.ViewModels.BuildOutConditionType */
export var BuildOutConditionType;
(function (BuildOutConditionType) {
    BuildOutConditionType[BuildOutConditionType["None"] = 0] = "None";
    BuildOutConditionType[BuildOutConditionType["PartiallyDemolished"] = 1] = "PartiallyDemolished";
    BuildOutConditionType[BuildOutConditionType["NeedsRenovation"] = 2] = "NeedsRenovation";
    BuildOutConditionType[BuildOutConditionType["Average"] = 3] = "Average";
    BuildOutConditionType[BuildOutConditionType["Excellent"] = 4] = "Excellent";
    BuildOutConditionType[BuildOutConditionType["Trophy"] = 5] = "Trophy";
})(BuildOutConditionType || (BuildOutConditionType = {}));
/** CoStar.Api.Listings.ViewModels.ValueAddedTaxType */
export var ValueAddedTaxType;
(function (ValueAddedTaxType) {
    ValueAddedTaxType[ValueAddedTaxType["None"] = 0] = "None";
    ValueAddedTaxType[ValueAddedTaxType["ChargesIncluded"] = 1] = "ChargesIncluded";
    ValueAddedTaxType[ValueAddedTaxType["ChargesAndTaxesExcluded"] = 2] = "ChargesAndTaxesExcluded";
    ValueAddedTaxType[ValueAddedTaxType["ChargesAndTaxesIncluded"] = 3] = "ChargesAndTaxesIncluded";
})(ValueAddedTaxType || (ValueAddedTaxType = {}));
import { PropertyGroupType } from "../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.Listings.ViewModels.PropertyGroupType */
export { PropertyGroupType };
import { PropertyGroupSubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.Listings.ViewModels.PropertyGroupSubtype */
export { PropertyGroupSubtype };
/** CoStar.Api.Listings.ViewModels.ParkingType */
export var ParkingType;
(function (ParkingType) {
    ParkingType[ParkingType["None"] = 0] = "None";
    ParkingType[ParkingType["Surface"] = 1] = "Surface";
    ParkingType[ParkingType["SurfaceTandem"] = 2] = "SurfaceTandem";
    ParkingType[ParkingType["Covered"] = 3] = "Covered";
    ParkingType[ParkingType["CoveredTandem"] = 4] = "CoveredTandem";
    ParkingType[ParkingType["IndustrialTrailer"] = 5] = "IndustrialTrailer";
    ParkingType[ParkingType["OneCarGarage"] = 6] = "OneCarGarage";
    ParkingType[ParkingType["TwoCarGarage"] = 7] = "TwoCarGarage";
    ParkingType[ParkingType["Reserved"] = 8] = "Reserved";
    ParkingType[ParkingType["AttachedGarage"] = 9] = "AttachedGarage";
})(ParkingType || (ParkingType = {}));
/** CoStar.Api.Listings.ViewModels.ParkingCompositionType */
export var ParkingCompositionType;
(function (ParkingCompositionType) {
    ParkingCompositionType[ParkingCompositionType["None"] = 0] = "None";
    ParkingCompositionType[ParkingCompositionType["Asphalt"] = 1] = "Asphalt";
    ParkingCompositionType[ParkingCompositionType["Concrete"] = 2] = "Concrete";
    ParkingCompositionType[ParkingCompositionType["GravelDirt"] = 3] = "GravelDirt";
})(ParkingCompositionType || (ParkingCompositionType = {}));
/** CoStar.Api.Listings.ViewModels.UtilityType */
export var UtilityType;
(function (UtilityType) {
    UtilityType[UtilityType["None"] = 0] = "None";
    UtilityType[UtilityType["Lighting"] = 1] = "Lighting";
    UtilityType[UtilityType["Gas"] = 3] = "Gas";
    UtilityType[UtilityType["Water"] = 4] = "Water";
    UtilityType[UtilityType["Sewer"] = 5] = "Sewer";
    UtilityType[UtilityType["Heating"] = 6] = "Heating";
})(UtilityType || (UtilityType = {}));
/** CoStar.Api.Listings.ViewModels.UtilitySubtype */
export var UtilitySubtype;
(function (UtilitySubtype) {
    UtilitySubtype[UtilitySubtype["None"] = 0] = "None";
    UtilitySubtype[UtilitySubtype["CityWater"] = 1] = "CityWater";
    UtilitySubtype[UtilitySubtype["CountyWater"] = 2] = "CountyWater";
    UtilitySubtype[UtilitySubtype["Well"] = 3] = "Well";
    UtilitySubtype[UtilitySubtype["Natural"] = 4] = "Natural";
    UtilitySubtype[UtilitySubtype["Propane"] = 5] = "Propane";
    UtilitySubtype[UtilitySubtype["Electric"] = 6] = "Electric";
    UtilitySubtype[UtilitySubtype["Gas"] = 7] = "Gas";
    UtilitySubtype[UtilitySubtype["FiredOil"] = 8] = "FiredOil";
    UtilitySubtype[UtilitySubtype["SteamOil"] = 9] = "SteamOil";
    UtilitySubtype[UtilitySubtype["Fluorescent"] = 10] = "Fluorescent";
    UtilitySubtype[UtilitySubtype["Incandescent"] = 11] = "Incandescent";
    UtilitySubtype[UtilitySubtype["CitySewer"] = 18] = "CitySewer";
    UtilitySubtype[UtilitySubtype["CountySewer"] = 19] = "CountySewer";
    UtilitySubtype[UtilitySubtype["SepticField"] = 20] = "SepticField";
    UtilitySubtype[UtilitySubtype["MetalHalide"] = 21] = "MetalHalide";
    UtilitySubtype[UtilitySubtype["Sodium"] = 22] = "Sodium";
    UtilitySubtype[UtilitySubtype["Mercury"] = 23] = "Mercury";
    UtilitySubtype[UtilitySubtype["Vapor"] = 24] = "Vapor";
    UtilitySubtype[UtilitySubtype["Halogen"] = 25] = "Halogen";
    UtilitySubtype[UtilitySubtype["Halide"] = 26] = "Halide";
})(UtilitySubtype || (UtilitySubtype = {}));
/** CoStar.Api.Listings.ViewModels.MassMeasure */
export var MassMeasure;
(function (MassMeasure) {
    MassMeasure[MassMeasure["None"] = 0] = "None";
    MassMeasure[MassMeasure["ShortTon"] = 1] = "ShortTon";
    MassMeasure[MassMeasure["Tonne"] = 2] = "Tonne";
})(MassMeasure || (MassMeasure = {}));
/** CoStar.Api.Listings.ViewModels.RoomRateBasis */
export var RoomRateBasis;
(function (RoomRateBasis) {
    RoomRateBasis[RoomRateBasis["None"] = 0] = "None";
    RoomRateBasis[RoomRateBasis["Monthly"] = 1] = "Monthly";
    RoomRateBasis[RoomRateBasis["Daily"] = 2] = "Daily";
})(RoomRateBasis || (RoomRateBasis = {}));
/** CoStar.Api.Listings.ViewModels.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["PropertyForSale"] = 9] = "PropertyForSale";
    ListingType[ListingType["ResidentialPropertyForSale"] = 10] = "ResidentialPropertyForSale";
    ListingType[ListingType["CondoForSale"] = 11] = "CondoForSale";
    ListingType[ListingType["LandForSale"] = 12] = "LandForSale";
    ListingType[ListingType["CommercialPortfolioForSale"] = 13] = "CommercialPortfolioForSale";
    ListingType[ListingType["PropertyDirectSpaceForLease"] = 14] = "PropertyDirectSpaceForLease";
    ListingType[ListingType["ConsolidatedCondosForSale"] = 15] = "ConsolidatedCondosForSale";
    ListingType[ListingType["BuildingParkDirectSpaceLease"] = 16] = "BuildingParkDirectSpaceLease";
    ListingType[ListingType["ShoppingCenterDirectSpaceForLease"] = 17] = "ShoppingCenterDirectSpaceForLease";
    ListingType[ListingType["LandDirectForLease"] = 18] = "LandDirectForLease";
    ListingType[ListingType["CommercialSublease"] = 19] = "CommercialSublease";
    ListingType[ListingType["CommercialLeaseAssignment"] = 20] = "CommercialLeaseAssignment";
    ListingType[ListingType["PropertyCoWorking"] = 21] = "PropertyCoWorking";
    ListingType[ListingType["PropertyForAuction"] = 22] = "PropertyForAuction";
    ListingType[ListingType["LandForAuction"] = 23] = "LandForAuction";
    ListingType[ListingType["CondoForAuction"] = 24] = "CondoForAuction";
    ListingType[ListingType["PropertyLoanForAuction"] = 25] = "PropertyLoanForAuction";
    ListingType[ListingType["CommercialPortfolioForAuction"] = 26] = "CommercialPortfolioForAuction";
    ListingType[ListingType["DisconnectedForSale"] = 27] = "DisconnectedForSale";
    ListingType[ListingType["DisconnectedSpaceForLease"] = 28] = "DisconnectedSpaceForLease";
})(ListingType || (ListingType = {}));
/** CoStar.Api.Listings.ViewModels.PropertySubtype */
export var PropertySubtype;
(function (PropertySubtype) {
    PropertySubtype[PropertySubtype["None"] = 0] = "None";
    PropertySubtype[PropertySubtype["FlexLightManufacturing"] = 1] = "FlexLightManufacturing";
    PropertySubtype[PropertySubtype["FlexResearchAndDevelopment"] = 2] = "FlexResearchAndDevelopment";
    PropertySubtype[PropertySubtype["FlexShowroom"] = 3] = "FlexShowroom";
    PropertySubtype[PropertySubtype["GeneralRetailAutoDealership"] = 4] = "GeneralRetailAutoDealership";
    PropertySubtype[PropertySubtype["GeneralRetailAutoRepair"] = 5] = "GeneralRetailAutoRepair";
    PropertySubtype[PropertySubtype["GeneralRetailBank"] = 6] = "GeneralRetailBank";
    PropertySubtype[PropertySubtype["GeneralRetailBar"] = 7] = "GeneralRetailBar";
    PropertySubtype[PropertySubtype["SpecialtyCarwash"] = 8] = "SpecialtyCarwash";
    PropertySubtype[PropertySubtype["GeneralRetailConvenienceStore"] = 9] = "GeneralRetailConvenienceStore";
    PropertySubtype[PropertySubtype["GeneralRetailDaycareCenter"] = 10] = "GeneralRetailDaycareCenter";
    PropertySubtype[PropertySubtype["GeneralRetailDrugstore"] = 11] = "GeneralRetailDrugstore";
    PropertySubtype[PropertySubtype["GeneralRetailFastFood"] = 12] = "GeneralRetailFastFood";
    PropertySubtype[PropertySubtype["GeneralRetailFuneralHome"] = 13] = "GeneralRetailFuneralHome";
    PropertySubtype[PropertySubtype["GeneralRetailFreestanding"] = 14] = "GeneralRetailFreestanding";
    PropertySubtype[PropertySubtype["GeneralRetailGardenCenter"] = 15] = "GeneralRetailGardenCenter";
    PropertySubtype[PropertySubtype["SpecialtyParkingGarage"] = 16] = "SpecialtyParkingGarage";
    PropertySubtype[PropertySubtype["SpecialtyParkingLot"] = 17] = "SpecialtyParkingLot";
    PropertySubtype[PropertySubtype["GeneralRetailRestaurant"] = 18] = "GeneralRetailRestaurant";
    PropertySubtype[PropertySubtype["GeneralRetailServiceStation"] = 19] = "GeneralRetailServiceStation";
    PropertySubtype[PropertySubtype["GeneralRetailStorefront"] = 20] = "GeneralRetailStorefront";
    PropertySubtype[PropertySubtype["GeneralRetailStorefrontRetailOffice"] = 21] = "GeneralRetailStorefrontRetailOffice";
    PropertySubtype[PropertySubtype["GeneralRetailStorefrontRetailResidential"] = 22] = "GeneralRetailStorefrontRetailResidential";
    PropertySubtype[PropertySubtype["GeneralRetailSupermarket"] = 23] = "GeneralRetailSupermarket";
    PropertySubtype[PropertySubtype["GeneralRetailTruckStop"] = 24] = "GeneralRetailTruckStop";
    PropertySubtype[PropertySubtype["GeneralRetailVeterinarianKennel"] = 25] = "GeneralRetailVeterinarianKennel";
    PropertySubtype[PropertySubtype["HealthcareAssistedLiving"] = 26] = "HealthcareAssistedLiving";
    PropertySubtype[PropertySubtype["HealthcareCongregateSeniorHousing"] = 27] = "HealthcareCongregateSeniorHousing";
    PropertySubtype[PropertySubtype["HealthcareContinuingCareRetirementCommunity"] = 28] = "HealthcareContinuingCareRetirementCommunity";
    PropertySubtype[PropertySubtype["HealthcareHospital"] = 29] = "HealthcareHospital";
    PropertySubtype[PropertySubtype["HealthcareRehabilitationCenter"] = 30] = "HealthcareRehabilitationCenter";
    PropertySubtype[PropertySubtype["HealthcareSkilledNursingFacility"] = 31] = "HealthcareSkilledNursingFacility";
    PropertySubtype[PropertySubtype["HospitalityHotel"] = 32] = "HospitalityHotel";
    PropertySubtype[PropertySubtype["HospitalityHotelCasino"] = 33] = "HospitalityHotelCasino";
    PropertySubtype[PropertySubtype["HospitalityMotel"] = 34] = "HospitalityMotel";
    PropertySubtype[PropertySubtype["SpecialtyAirport"] = 35] = "SpecialtyAirport";
    PropertySubtype[PropertySubtype["SpecialtyAirplaneHangar"] = 36] = "SpecialtyAirplaneHangar";
    PropertySubtype[PropertySubtype["SpecialtyAutoSalvageFacility"] = 37] = "SpecialtyAutoSalvageFacility";
    PropertySubtype[PropertySubtype["SpecialtyCementGravelPlant"] = 38] = "SpecialtyCementGravelPlant";
    PropertySubtype[PropertySubtype["SpecialtyChemicalOilRefinery"] = 39] = "SpecialtyChemicalOilRefinery";
    PropertySubtype[PropertySubtype["IndustrialTelecomHotelDataHosting"] = 40] = "IndustrialTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["IndustrialDistribution"] = 41] = "IndustrialDistribution";
    PropertySubtype[PropertySubtype["IndustrialFoodProcessing"] = 42] = "IndustrialFoodProcessing";
    PropertySubtype[PropertySubtype["SpecialtyLandfill"] = 43] = "SpecialtyLandfill";
    PropertySubtype[PropertySubtype["IndustrialManufacturing"] = 44] = "IndustrialManufacturing";
    PropertySubtype[PropertySubtype["SpecialtyRailroadYard"] = 45] = "SpecialtyRailroadYard";
    PropertySubtype[PropertySubtype["IndustrialRefrigerationColdStorage"] = 46] = "IndustrialRefrigerationColdStorage";
    PropertySubtype[PropertySubtype["SpecialtySelfStorage"] = 47] = "SpecialtySelfStorage";
    PropertySubtype[PropertySubtype["SpecialtyShipyard"] = 48] = "SpecialtyShipyard";
    PropertySubtype[PropertySubtype["IndustrialShowroom"] = 49] = "IndustrialShowroom";
    PropertySubtype[PropertySubtype["IndustrialTruckTerminal"] = 50] = "IndustrialTruckTerminal";
    PropertySubtype[PropertySubtype["SpecialtyUtilitySubstation"] = 51] = "SpecialtyUtilitySubstation";
    PropertySubtype[PropertySubtype["IndustrialWarehouse"] = 52] = "IndustrialWarehouse";
    PropertySubtype[PropertySubtype["SpecialtyWaterTreatmentFacility"] = 53] = "SpecialtyWaterTreatmentFacility";
    PropertySubtype[PropertySubtype["MixedUse"] = 57] = "MixedUse";
    PropertySubtype[PropertySubtype["MultifamilyApartments"] = 58] = "MultifamilyApartments";
    PropertySubtype[PropertySubtype["MultifamilyManufacturedHousingMobileHomePark"] = 62] = "MultifamilyManufacturedHousingMobileHomePark";
    PropertySubtype[PropertySubtype["OfficeLoftCreativeSpace"] = 63] = "OfficeLoftCreativeSpace";
    PropertySubtype[PropertySubtype["OfficeMedical"] = 64] = "OfficeMedical";
    PropertySubtype[PropertySubtype["SpecialtyCemeteryMausoleum"] = 72] = "SpecialtyCemeteryMausoleum";
    PropertySubtype[PropertySubtype["SpecialtyCorrectionalFacility"] = 73] = "SpecialtyCorrectionalFacility";
    PropertySubtype[PropertySubtype["SpecialtyLodgeMeetingHall"] = 74] = "SpecialtyLodgeMeetingHall";
    PropertySubtype[PropertySubtype["SpecialtyMarina"] = 75] = "SpecialtyMarina";
    PropertySubtype[PropertySubtype["SpecialtyMovieRadioTVStudio"] = 76] = "SpecialtyMovieRadioTVStudio";
    PropertySubtype[PropertySubtype["SpecialtyPoliceFireStation"] = 77] = "SpecialtyPoliceFireStation";
    PropertySubtype[PropertySubtype["SpecialtyPostOffice"] = 78] = "SpecialtyPostOffice";
    PropertySubtype[PropertySubtype["SpecialtyPublicLibrary"] = 79] = "SpecialtyPublicLibrary";
    PropertySubtype[PropertySubtype["SpecialtyRadioTVTransmissionFacilities"] = 80] = "SpecialtyRadioTVTransmissionFacilities";
    PropertySubtype[PropertySubtype["SpecialtyReligiousFacility"] = 81] = "SpecialtyReligiousFacility";
    PropertySubtype[PropertySubtype["SpecialtySchools"] = 82] = "SpecialtySchools";
    PropertySubtype[PropertySubtype["SpecialtyTrailerCamperPark"] = 83] = "SpecialtyTrailerCamperPark";
    PropertySubtype[PropertySubtype["SpecialtyWineryVineyard"] = 84] = "SpecialtyWineryVineyard";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentAmusementPark"] = 85] = "SportsAndEntertainmentAmusementPark";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentBaseballField"] = 86] = "SportsAndEntertainmentBaseballField";
    PropertySubtype[PropertySubtype["GeneralRetailBowlingAlley"] = 87] = "GeneralRetailBowlingAlley";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentCasino"] = 88] = "SportsAndEntertainmentCasino";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentGolfCourseDrivingRange"] = 89] = "SportsAndEntertainmentGolfCourseDrivingRange";
    PropertySubtype[PropertySubtype["GeneralRetailHealthClub"] = 90] = "GeneralRetailHealthClub";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentHorseStables"] = 91] = "SportsAndEntertainmentHorseStables";
    PropertySubtype[PropertySubtype["GeneralRetailMovieTheatre"] = 92] = "GeneralRetailMovieTheatre";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentRacetrack"] = 93] = "SportsAndEntertainmentRacetrack";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentSkatingRink"] = 94] = "SportsAndEntertainmentSkatingRink";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentSwimmingPool"] = 95] = "SportsAndEntertainmentSwimmingPool";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentTheaterConcertHall"] = 96] = "SportsAndEntertainmentTheaterConcertHall";
    PropertySubtype[PropertySubtype["IndustrialService"] = 97] = "IndustrialService";
    PropertySubtype[PropertySubtype["OfficeTelecomHotelDataHosting"] = 98] = "OfficeTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["FlexTelecomHotelDataHosting"] = 99] = "FlexTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["FlexLightDistribution"] = 104] = "FlexLightDistribution";
    PropertySubtype[PropertySubtype["SpecialtyWaterRetentionFacility"] = 105] = "SpecialtyWaterRetentionFacility";
    PropertySubtype[PropertySubtype["SpecialtySororityFraternityHouse"] = 106] = "SpecialtySororityFraternityHouse";
    PropertySubtype[PropertySubtype["HospitalitySingleRoomOccupancyHotel"] = 107] = "HospitalitySingleRoomOccupancyHotel";
    PropertySubtype[PropertySubtype["SpecialtyShelter"] = 108] = "SpecialtyShelter";
    PropertySubtype[PropertySubtype["SpecialtyRecyclingCenter"] = 109] = "SpecialtyRecyclingCenter";
    PropertySubtype[PropertySubtype["OfficeOfficeResidential"] = 110] = "OfficeOfficeResidential";
    PropertySubtype[PropertySubtype["OfficeOfficeLiveWorkUnit"] = 112] = "OfficeOfficeLiveWorkUnit";
    PropertySubtype[PropertySubtype["SpecialtyLumberyard"] = 113] = "SpecialtyLumberyard";
    PropertySubtype[PropertySubtype["OfficeIndustrialLiveWorkUnit"] = 114] = "OfficeIndustrialLiveWorkUnit";
    PropertySubtype[PropertySubtype["SpecialtyDriveInMovie"] = 115] = "SpecialtyDriveInMovie";
    PropertySubtype[PropertySubtype["GeneralRetailDepartmentStore"] = 116] = "GeneralRetailDepartmentStore";
    PropertySubtype[PropertySubtype["SpecialtyContractorStorageYard"] = 117] = "SpecialtyContractorStorageYard";
    PropertySubtype[PropertySubtype["OfficeBusinessPark"] = 118] = "OfficeBusinessPark";
    PropertySubtype[PropertySubtype["OfficeCallCenter"] = 119] = "OfficeCallCenter";
    PropertySubtype[PropertySubtype["OfficeD1"] = 120] = "OfficeD1";
    PropertySubtype[PropertySubtype["OfficeD2"] = 121] = "OfficeD2";
    PropertySubtype[PropertySubtype["OfficeServicedOffices"] = 122] = "OfficeServicedOffices";
    PropertySubtype[PropertySubtype["FlexBank"] = 123] = "FlexBank";
    PropertySubtype[PropertySubtype["FlexBusinessPark"] = 124] = "FlexBusinessPark";
    PropertySubtype[PropertySubtype["FlexCafe"] = 125] = "FlexCafe";
    PropertySubtype[PropertySubtype["FlexFoodCourt"] = 126] = "FlexFoodCourt";
    PropertySubtype[PropertySubtype["FlexMixedRetail"] = 127] = "FlexMixedRetail";
    PropertySubtype[PropertySubtype["FlexOutletCenter"] = 128] = "FlexOutletCenter";
    PropertySubtype[PropertySubtype["FlexPublicHouse"] = 129] = "FlexPublicHouse";
    PropertySubtype[PropertySubtype["FlexRetailOutOfTown"] = 130] = "FlexRetailOutOfTown";
    PropertySubtype[PropertySubtype["FlexSuperRegional"] = 131] = "FlexSuperRegional";
    PropertySubtype[PropertySubtype["FlexTradeCounterPark"] = 132] = "FlexTradeCounterPark";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentAllLeisure"] = 133] = "SportsAndEntertainmentAllLeisure";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentFitnessCenter"] = 134] = "SportsAndEntertainmentFitnessCenter";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentNightclub"] = 135] = "SportsAndEntertainmentNightclub";
    PropertySubtype[PropertySubtype["SpecialtyConference"] = 136] = "SpecialtyConference";
    PropertySubtype[PropertySubtype["SpecialtyOfficeAndIndustrial"] = 137] = "SpecialtyOfficeAndIndustrial";
    PropertySubtype[PropertySubtype["IndustrialLightIndustrial"] = 139] = "IndustrialLightIndustrial";
    PropertySubtype[PropertySubtype["HealthcareIndependentLiving"] = 142] = "HealthcareIndependentLiving";
    PropertySubtype[PropertySubtype["MultifamilyDormitory"] = 143] = "MultifamilyDormitory";
    PropertySubtype[PropertySubtype["SpecialtyResidentialIncome"] = 144] = "SpecialtyResidentialIncome";
    PropertySubtype[PropertySubtype["OfficeBuilding"] = 145] = "OfficeBuilding";
    PropertySubtype[PropertySubtype["RetailBuilding"] = 146] = "RetailBuilding";
    PropertySubtype[PropertySubtype["QuickService"] = 147] = "QuickService";
    PropertySubtype[PropertySubtype["ServicedApartment"] = 148] = "ServicedApartment";
    PropertySubtype[PropertySubtype["Hostel"] = 149] = "Hostel";
    PropertySubtype[PropertySubtype["BedAndBreakfast"] = 150] = "BedAndBreakfast";
})(PropertySubtype || (PropertySubtype = {}));
import { LandType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Listings.ViewModels.LandType */
export { LandType };
import { ApartmentStyleType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.Listings.ViewModels.ApartmentStyleType */
export { ApartmentStyleType };
import { BuildingClass } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Listings.ViewModels.BuildingClass */
export { BuildingClass };
/** CoStar.Api.Listings.ViewModels.StarRating */
export var StarRating;
(function (StarRating) {
    StarRating[StarRating["None"] = 0] = "None";
    StarRating[StarRating["OneStar"] = 1] = "OneStar";
    StarRating[StarRating["TwoStars"] = 2] = "TwoStars";
    StarRating[StarRating["ThreeStars"] = 3] = "ThreeStars";
    StarRating[StarRating["FourStars"] = 4] = "FourStars";
    StarRating[StarRating["FiveStars"] = 5] = "FiveStars";
})(StarRating || (StarRating = {}));
import { ConstructionStatus } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.Listings.ViewModels.ConstructionStatus */
export { ConstructionStatus };
/** CoStar.Api.Listings.ViewModels.ConstructionMaterial */
export var ConstructionMaterial;
(function (ConstructionMaterial) {
    ConstructionMaterial[ConstructionMaterial["None"] = 0] = "None";
    ConstructionMaterial[ConstructionMaterial["Masonry"] = 1] = "Masonry";
    ConstructionMaterial[ConstructionMaterial["Metal"] = 2] = "Metal";
    ConstructionMaterial[ConstructionMaterial["ReinforcedConcrete"] = 3] = "ReinforcedConcrete";
    ConstructionMaterial[ConstructionMaterial["Steel"] = 4] = "Steel";
    ConstructionMaterial[ConstructionMaterial["WoodFrame"] = 5] = "WoodFrame";
    ConstructionMaterial[ConstructionMaterial["Brownstone"] = 6] = "Brownstone";
})(ConstructionMaterial || (ConstructionMaterial = {}));
/** CoStar.Api.Listings.ViewModels.ShoppingCenterType */
export var ShoppingCenterType;
(function (ShoppingCenterType) {
    ShoppingCenterType[ShoppingCenterType["None"] = 0] = "None";
    ShoppingCenterType[ShoppingCenterType["AirportRetail"] = 1] = "AirportRetail";
    ShoppingCenterType[ShoppingCenterType["CommunityCenter"] = 2] = "CommunityCenter";
    ShoppingCenterType[ShoppingCenterType["LifestyleCenter"] = 3] = "LifestyleCenter";
    ShoppingCenterType[ShoppingCenterType["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    ShoppingCenterType[ShoppingCenterType["OutletCenter"] = 5] = "OutletCenter";
    ShoppingCenterType[ShoppingCenterType["PowerCenter"] = 6] = "PowerCenter";
    ShoppingCenterType[ShoppingCenterType["RegionalMall"] = 7] = "RegionalMall";
    ShoppingCenterType[ShoppingCenterType["ThemeFestivalCenter"] = 8] = "ThemeFestivalCenter";
    ShoppingCenterType[ShoppingCenterType["StripCenter"] = 9] = "StripCenter";
    ShoppingCenterType[ShoppingCenterType["SuperRegionalMall"] = 10] = "SuperRegionalMall";
    ShoppingCenterType[ShoppingCenterType["RegionalPrime"] = 11] = "RegionalPrime";
    ShoppingCenterType[ShoppingCenterType["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    ShoppingCenterType[ShoppingCenterType["UrbanCentre"] = 13] = "UrbanCentre";
    ShoppingCenterType[ShoppingCenterType["District"] = 14] = "District";
    ShoppingCenterType[ShoppingCenterType["SolusUnit"] = 15] = "SolusUnit";
    ShoppingCenterType[ShoppingCenterType["ShoppingPark"] = 16] = "ShoppingPark";
    ShoppingCenterType[ShoppingCenterType["RetailPark"] = 17] = "RetailPark";
    ShoppingCenterType[ShoppingCenterType["LeisurePark"] = 18] = "LeisurePark";
    ShoppingCenterType[ShoppingCenterType["OfficePark"] = 19] = "OfficePark";
})(ShoppingCenterType || (ShoppingCenterType = {}));
/** CoStar.Api.Listings.ViewModels.OffsiteImprovement */
export var OffsiteImprovement;
(function (OffsiteImprovement) {
    OffsiteImprovement[OffsiteImprovement["None"] = 0] = "None";
    OffsiteImprovement[OffsiteImprovement["Sewer"] = 1] = "Sewer";
    OffsiteImprovement[OffsiteImprovement["Water"] = 2] = "Water";
    OffsiteImprovement[OffsiteImprovement["Electricity"] = 3] = "Electricity";
    OffsiteImprovement[OffsiteImprovement["Gas"] = 4] = "Gas";
    OffsiteImprovement[OffsiteImprovement["Streets"] = 5] = "Streets";
    OffsiteImprovement[OffsiteImprovement["CurbGutterSidewalk"] = 6] = "CurbGutterSidewalk";
    OffsiteImprovement[OffsiteImprovement["Cable"] = 7] = "Cable";
    OffsiteImprovement[OffsiteImprovement["Telephone"] = 8] = "Telephone";
    OffsiteImprovement[OffsiteImprovement["Irrigation"] = 9] = "Irrigation";
})(OffsiteImprovement || (OffsiteImprovement = {}));
/** CoStar.Api.Listings.ViewModels.CorridorType */
export var CorridorType;
(function (CorridorType) {
    CorridorType[CorridorType["None"] = 0] = "None";
    CorridorType[CorridorType["Interior"] = 1] = "Interior";
    CorridorType[CorridorType["Exterior"] = 2] = "Exterior";
})(CorridorType || (CorridorType = {}));
/** CoStar.Api.Listings.ViewModels.PropertyFeatures */
export var PropertyFeatures;
(function (PropertyFeatures) {
    PropertyFeatures[PropertyFeatures["None"] = 0] = "None";
    PropertyFeatures[PropertyFeatures["RailAccess"] = 1] = "RailAccess";
    PropertyFeatures[PropertyFeatures["Sprinkler"] = 2] = "Sprinkler";
    PropertyFeatures[PropertyFeatures["HeavyPower"] = 4] = "HeavyPower";
    PropertyFeatures[PropertyFeatures["Crane"] = 8] = "Crane";
})(PropertyFeatures || (PropertyFeatures = {}));
/** CoStar.Api.Listings.ViewModels.SprinklerType */
export var SprinklerType;
(function (SprinklerType) {
    SprinklerType[SprinklerType["None"] = 0] = "None";
    SprinklerType[SprinklerType["Wet"] = 1] = "Wet";
    SprinklerType[SprinklerType["Dry"] = 2] = "Dry";
    SprinklerType[SprinklerType["EarlySuppressionFastResponse"] = 3] = "EarlySuppressionFastResponse";
    SprinklerType[SprinklerType["Unknown"] = 4] = "Unknown";
})(SprinklerType || (SprinklerType = {}));
/** CoStar.Api.Listings.ViewModels.LeedCertifiedType */
export var LeedCertifiedType;
(function (LeedCertifiedType) {
    LeedCertifiedType[LeedCertifiedType["None"] = 0] = "None";
    LeedCertifiedType[LeedCertifiedType["Certified"] = 1] = "Certified";
    LeedCertifiedType[LeedCertifiedType["Gold"] = 2] = "Gold";
    LeedCertifiedType[LeedCertifiedType["Platinum"] = 3] = "Platinum";
    LeedCertifiedType[LeedCertifiedType["Silver"] = 4] = "Silver";
    LeedCertifiedType[LeedCertifiedType["PreCertified"] = 5] = "PreCertified";
    LeedCertifiedType[LeedCertifiedType["Registered"] = 6] = "Registered";
})(LeedCertifiedType || (LeedCertifiedType = {}));
import { BreeamType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.Listings.ViewModels.BreeamType */
export { BreeamType };
/** CoStar.Api.Listings.ViewModels.HotelClass */
export var HotelClass;
(function (HotelClass) {
    HotelClass[HotelClass["None"] = 0] = "None";
    HotelClass[HotelClass["Luxury"] = 1] = "Luxury";
    HotelClass[HotelClass["UpperUpscale"] = 2] = "UpperUpscale";
    HotelClass[HotelClass["Upscale"] = 3] = "Upscale";
    HotelClass[HotelClass["UpperMidscale"] = 4] = "UpperMidscale";
    HotelClass[HotelClass["Midscale"] = 5] = "Midscale";
    HotelClass[HotelClass["Economy"] = 6] = "Economy";
})(HotelClass || (HotelClass = {}));
/** CoStar.Api.Listings.ViewModels.Visibility */
export var Visibility;
(function (Visibility) {
    Visibility[Visibility["None"] = 0] = "None";
    Visibility[Visibility["CoStarSuite"] = 1] = "CoStarSuite";
    Visibility[Visibility["PremiumSearch"] = 2] = "PremiumSearch";
    Visibility[Visibility["SeoSearch"] = 3] = "SeoSearch";
    Visibility[Visibility["FreeSearch"] = 4] = "FreeSearch";
    Visibility[Visibility["LoopLinkSearch"] = 5] = "LoopLinkSearch";
})(Visibility || (Visibility = {}));
/** CoStar.Api.Listings.ViewModels.ListingPlacardOptions */
export var ListingPlacardOptions;
(function (ListingPlacardOptions) {
    ListingPlacardOptions[ListingPlacardOptions["None"] = 0] = "None";
    ListingPlacardOptions[ListingPlacardOptions["RestrictedVisibility"] = 1] = "RestrictedVisibility";
    ListingPlacardOptions[ListingPlacardOptions["Licensed"] = 2] = "Licensed";
})(ListingPlacardOptions || (ListingPlacardOptions = {}));
/** CoStar.Api.Listings.ViewModels.AvailabilityType */
export var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType[AvailabilityType["None"] = 0] = "None";
    AvailabilityType[AvailabilityType["ThirtyDays"] = 1] = "ThirtyDays";
    AvailabilityType[AvailabilityType["SixtyDays"] = 2] = "SixtyDays";
    AvailabilityType[AvailabilityType["NinetyDays"] = 3] = "NinetyDays";
    AvailabilityType[AvailabilityType["OneHundredTwentyDays"] = 4] = "OneHundredTwentyDays";
    AvailabilityType[AvailabilityType["ToBeDetermined"] = 5] = "ToBeDetermined";
    AvailabilityType[AvailabilityType["Arranged"] = 6] = "Arranged";
    AvailabilityType[AvailabilityType["Negotiable"] = 7] = "Negotiable";
})(AvailabilityType || (AvailabilityType = {}));
/** CoStar.Api.Listings.ViewModels.StoreType */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["None"] = 0] = "None";
    StoreType[StoreType["EmploymentAgency"] = 1] = "EmploymentAgency";
    StoreType[StoreType["Bagel"] = 2] = "Bagel";
    StoreType[StoreType["Fitness"] = 3] = "Fitness";
    StoreType[StoreType["AutoShowroom"] = 4] = "AutoShowroom";
    StoreType[StoreType["FilmProcessing"] = 5] = "FilmProcessing";
    StoreType[StoreType["SpecialtyFoods"] = 6] = "SpecialtyFoods";
    StoreType[StoreType["CardGifts"] = 7] = "CardGifts";
    StoreType[StoreType["OtherRetail"] = 9] = "OtherRetail";
    StoreType[StoreType["IceCream"] = 10] = "IceCream";
    StoreType[StoreType["Books"] = 11] = "Books";
    StoreType[StoreType["OtherServices"] = 13] = "OtherServices";
    StoreType[StoreType["CandyNuts"] = 14] = "CandyNuts";
    StoreType[StoreType["ConsumerElectronics"] = 16] = "ConsumerElectronics";
    StoreType[StoreType["Floorcovering"] = 17] = "Floorcovering";
    StoreType[StoreType["MusicInstruments"] = 18] = "MusicInstruments";
    StoreType[StoreType["LeatherLuggagePurses"] = 19] = "LeatherLuggagePurses";
    StoreType[StoreType["Tobacco"] = 20] = "Tobacco";
    StoreType[StoreType["Automotive"] = 21] = "Automotive";
    StoreType[StoreType["GasolineStation"] = 22] = "GasolineStation";
    StoreType[StoreType["NailSalon"] = 23] = "NailSalon";
    StoreType[StoreType["SalonBarberSpa"] = 24] = "SalonBarberSpa";
    StoreType[StoreType["ChildrenApparel"] = 25] = "ChildrenApparel";
    StoreType[StoreType["CocktailBar"] = 26] = "CocktailBar";
    StoreType[StoreType["TravelAgent"] = 27] = "TravelAgent";
    StoreType[StoreType["HomeImprovement"] = 28] = "HomeImprovement";
    StoreType[StoreType["ChinaGlass"] = 29] = "ChinaGlass";
    StoreType[StoreType["Coffee"] = 30] = "Coffee";
    StoreType[StoreType["Bakery"] = 31] = "Bakery";
    StoreType[StoreType["Laundry"] = 32] = "Laundry";
    StoreType[StoreType["WindowCoverings"] = 33] = "WindowCoverings";
    StoreType[StoreType["ArtCrafts"] = 35] = "ArtCrafts";
    StoreType[StoreType["Supermarket"] = 36] = "Supermarket";
    StoreType[StoreType["DoctorDentist"] = 37] = "DoctorDentist";
    StoreType[StoreType["Florist"] = 38] = "Florist";
    StoreType[StoreType["KeyShop"] = 39] = "KeyShop";
    StoreType[StoreType["DepartmentStore"] = 40] = "DepartmentStore";
    StoreType[StoreType["OffPrice"] = 41] = "OffPrice";
    StoreType[StoreType["LadiesApparel"] = 42] = "LadiesApparel";
    StoreType[StoreType["Bank"] = 43] = "Bank";
    StoreType[StoreType["ArtGallery"] = 44] = "ArtGallery";
    StoreType[StoreType["OfficeSupply"] = 45] = "OfficeSupply";
    StoreType[StoreType["Drugstore"] = 46] = "Drugstore";
    StoreType[StoreType["LampsLighting"] = 47] = "LampsLighting";
    StoreType[StoreType["GameStore"] = 48] = "GameStore";
    StoreType[StoreType["Shoes"] = 49] = "Shoes";
    StoreType[StoreType["BowlingBilliards"] = 50] = "BowlingBilliards";
    StoreType[StoreType["Hardware"] = 52] = "Hardware";
    StoreType[StoreType["InvestmentService"] = 53] = "InvestmentService";
    StoreType[StoreType["AccountingTaxPreparation"] = 56] = "AccountingTaxPreparation";
    StoreType[StoreType["FastFood"] = 57] = "FastFood";
    StoreType[StoreType["HealthFood"] = 58] = "HealthFood";
    StoreType[StoreType["WirelessCommunication"] = 60] = "WirelessCommunication";
    StoreType[StoreType["Imports"] = 61] = "Imports";
    StoreType[StoreType["Newsstand"] = 62] = "Newsstand";
    StoreType[StoreType["Arcade"] = 63] = "Arcade";
    StoreType[StoreType["PetShopSupplies"] = 64] = "PetShopSupplies";
    StoreType[StoreType["FabricShop"] = 65] = "FabricShop";
    StoreType[StoreType["UnisexApparel"] = 66] = "UnisexApparel";
    StoreType[StoreType["Formalwear"] = 70] = "Formalwear";
    StoreType[StoreType["DiscountStore"] = 71] = "DiscountStore";
    StoreType[StoreType["Cinema"] = 72] = "Cinema";
    StoreType[StoreType["Accessory"] = 73] = "Accessory";
    StoreType[StoreType["Cafeteria"] = 74] = "Cafeteria";
    StoreType[StoreType["PaintWallpaper"] = 75] = "PaintWallpaper";
    StoreType[StoreType["WholesaleClub"] = 76] = "WholesaleClub";
    StoreType[StoreType["BikeShop"] = 77] = "BikeShop";
    StoreType[StoreType["FurnitureMattress"] = 78] = "FurnitureMattress";
    StoreType[StoreType["Toys"] = 79] = "Toys";
    StoreType[StoreType["HomeAccessories"] = 80] = "HomeAccessories";
    StoreType[StoreType["Photographer"] = 81] = "Photographer";
    StoreType[StoreType["ChurchHall"] = 83] = "ChurchHall";
    StoreType[StoreType["ConvenienceMarket"] = 84] = "ConvenienceMarket";
    StoreType[StoreType["OtherOffice"] = 86] = "OtherOffice";
    StoreType[StoreType["DonutShop"] = 87] = "DonutShop";
    StoreType[StoreType["Liquor"] = 88] = "Liquor";
    StoreType[StoreType["VideogamesRental"] = 89] = "VideogamesRental";
    StoreType[StoreType["Stationery"] = 90] = "Stationery";
    StoreType[StoreType["Insurance"] = 91] = "Insurance";
    StoreType[StoreType["BusinCopyPostService"] = 92] = "BusinCopyPostService";
    StoreType[StoreType["DiscountGrocer"] = 93] = "DiscountGrocer";
    StoreType[StoreType["Atm"] = 94] = "Atm";
    StoreType[StoreType["Optical"] = 96] = "Optical";
    StoreType[StoreType["ButcherFishMarket"] = 97] = "ButcherFishMarket";
    StoreType[StoreType["Candles"] = 98] = "Candles";
    StoreType[StoreType["KitchenDining"] = 99] = "KitchenDining";
    StoreType[StoreType["Legal"] = 100] = "Legal";
    StoreType[StoreType["Healthcare"] = 101] = "Healthcare";
    StoreType[StoreType["SportingGoods"] = 102] = "SportingGoods";
    StoreType[StoreType["MusicVideogames"] = 103] = "MusicVideogames";
    StoreType[StoreType["Hobby"] = 104] = "Hobby";
    StoreType[StoreType["GourmetMarket"] = 105] = "GourmetMarket";
    StoreType[StoreType["Cameras"] = 106] = "Cameras";
    StoreType[StoreType["Appliances"] = 107] = "Appliances";
    StoreType[StoreType["MenApparel"] = 109] = "MenApparel";
    StoreType[StoreType["Dance"] = 110] = "Dance";
    StoreType[StoreType["ShopRepair"] = 111] = "ShopRepair";
    StoreType[StoreType["Daycare"] = 112] = "Daycare";
    StoreType[StoreType["Cleaners"] = 114] = "Cleaners";
    StoreType[StoreType["Cookies"] = 115] = "Cookies";
    StoreType[StoreType["Pretzels"] = 116] = "Pretzels";
    StoreType[StoreType["SavingsLoan"] = 117] = "SavingsLoan";
    StoreType[StoreType["RealEstate"] = 118] = "RealEstate";
    StoreType[StoreType["NutritionCenter"] = 119] = "NutritionCenter";
    StoreType[StoreType["Restaurant"] = 120] = "Restaurant";
    StoreType[StoreType["RentalShop"] = 121] = "RentalShop";
    StoreType[StoreType["HealthBeautyAids"] = 122] = "HealthBeautyAids";
    StoreType[StoreType["JewelryWatches"] = 124] = "JewelryWatches";
    StoreType[StoreType["EyeWareAccessories"] = 125] = "EyeWareAccessories";
    StoreType[StoreType["AutoRental"] = 126] = "AutoRental";
    StoreType[StoreType["GardenPatioPool"] = 127] = "GardenPatioPool";
    StoreType[StoreType["CheckCashQuickLoans"] = 128] = "CheckCashQuickLoans";
    StoreType[StoreType["DrinksJuices"] = 129] = "DrinksJuices";
    StoreType[StoreType["DollarVarietyThrift"] = 130] = "DollarVarietyThrift";
    StoreType[StoreType["Marine"] = 131] = "Marine";
    StoreType[StoreType["Pawnshop"] = 132] = "Pawnshop";
    StoreType[StoreType["TanningSalon"] = 133] = "TanningSalon";
    StoreType[StoreType["AnimalCareGroom"] = 134] = "AnimalCareGroom";
    StoreType[StoreType["FinanceCompany"] = 135] = "FinanceCompany";
    StoreType[StoreType["HotelMotel"] = 136] = "HotelMotel";
    StoreType[StoreType["Pizza"] = 137] = "Pizza";
    StoreType[StoreType["SubSandwich"] = 138] = "SubSandwich";
    StoreType[StoreType["Yogurt"] = 139] = "Yogurt";
    StoreType[StoreType["AutoMaintenanceOilChange"] = 140] = "AutoMaintenanceOilChange";
    StoreType[StoreType["Massage"] = 141] = "Massage";
})(StoreType || (StoreType = {}));
import { AreaType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Listings.ViewModels.AreaType */
export { AreaType };
/** CoStar.Api.Listings.ViewModels.TenXEntityType */
export var TenXEntityType;
(function (TenXEntityType) {
    TenXEntityType[TenXEntityType["None"] = 0] = "None";
    TenXEntityType[TenXEntityType["Listing"] = 1] = "Listing";
    TenXEntityType[TenXEntityType["Property"] = 2] = "Property";
})(TenXEntityType || (TenXEntityType = {}));
export { Search, Detail, BrokerListingCounts, IntegrationTest, AuctionDetail, LoanDetail, PointsOfInterest, PropertyRecord, UnitMix };
